import { render, staticRenderFns } from "./TheDaySwiperFooter.vue?vue&type=template&id=de4fb37c"
import script from "./TheDaySwiperFooter.vue?vue&type=script&lang=js"
export * from "./TheDaySwiperFooter.vue?vue&type=script&lang=js"
import style0 from "./TheDaySwiperFooter.vue?vue&type=style&index=0&id=de4fb37c&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports